// Sprint 3 Story 3 — Helper für den persönlichen Abteilungs-Filter.
//
// Leerer Filter (= aus User-Preferences `visible_departments: []`) bedeutet:
// alle Abteilungen sind sichtbar. Sonst zeigen wir nur Projekte deren
// `department_ids` mindestens eine Schnittmenge mit dem Filter hat.

interface ProjectLike {
  department_ids: number[];
}

export function isProjectVisible(
  project: ProjectLike,
  visibleDepartments: number[]
): boolean {
  if (visibleDepartments.length === 0) return true;
  for (const did of project.department_ids) {
    if (visibleDepartments.includes(did)) return true;
  }
  // Projekte ohne jegliche Department-Zuordnung sind ebenfalls sichtbar,
  // damit nichts unerreichbar wird (Gesamtorganisation-Fallback in der DB
  // schützt zusätzlich).
  return project.department_ids.length === 0;
}
